import React, { useContext, useState } from 'react';

const AppSettingsContext = React.createContext();

export const AppSettingsProvider = ({ children }) => {
  const defaultSettings = { eventDates: [], appStatus: null };
  const [appSettings, setAppSettings] = useState(defaultSettings);
  const reset = () => {
    setAppSettings(defaultSettings);
  };
  return (
    <AppSettingsContext.Provider value={{ appSettings, setAppSettings, reset }}>
      {children}
    </AppSettingsContext.Provider>
  );
};

export const useAppSettings = () => {
  const { appSettings, setAppSettings, reset } = useContext(AppSettingsContext);
  return { appSettings, setAppSettings, reset };
};
